"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfRenewalQuoteMTADeclineWordings = void 0;
var WolfRenewalQuoteMTADeclineWordings = /** @class */ (function () {
    function WolfRenewalQuoteMTADeclineWordings() {
        this.defaultMessage = "Sorry, we can't insure you.";
        this.changeInDriversHistorySoft = "With the changes you are looking to make, we can no longer offer you a renewal quote due to the driver's driving history.";
        this.changeInDriversHistoryHard = "Sorry, we can no longer offer you a renewal quote due to the change of driving history.";
        this.changeInDriversAge = "With the changes you are looking to make, we can no longer offer you a renewal quote due to the driver's age.";
        this.changeInCarDetailsSoft = "With the changes you are looking to make, we can no longer offer you a renewal quote due to the change of car details.";
        this.changeInAddressHard = "Sorry, we can no longer offer you a renewal quote due to the change of address.";
        this.changeInRiskSoft = "With the changes you are looking to make, we can no longer offer you a renewal quote due to the change in risk.";
        this.changeInRiskHard = "Sorry, we can no longer offer you a renewal quote due to the change of details.";
        this.changeInCarUsage = "Sorry, we can no longer offer you a renewal quote due to the change of car usage.";
        this.calculationHalted = "Calculation halted - Too many input errors, Terminating Application";
        this.mtaLimitReached = this.defaultMessage;
    }
    return WolfRenewalQuoteMTADeclineWordings;
}());
exports.WolfRenewalQuoteMTADeclineWordings = WolfRenewalQuoteMTADeclineWordings;
//# sourceMappingURL=WolfRenewalQuoteMTADeclineWordings.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/declineWordings/WolfRenewalQuoteMTADeclineWordings.js
// module id = 3180
// module chunks = 0